import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { buildResponsiveTableData, renderResponsiveTableComponents, } from "../../../Shared/components/ResponsiveTable";
import setPriceWithCurrency from "../../../Shared/utils/currency";
import { GIFT_CARD_COLUMN_METADATA } from "./";
export const buildGiftCardTable = (options) => {
    const { giftCards, culture, onMoreInfo, excludeColumns = [] } = options;
    const columnConfig = GIFT_CARD_COLUMN_METADATA;
    // Row mapper function that transforms GiftCard into table row using pure descriptors
    const mapGiftCardToRow = (giftCard, helpers) => {
        // Create actions array for potential future expansion
        const actionButtons = [];
        // More info button (conditional)
        if (onMoreInfo) {
            actionButtons.push(helpers.createIconButton("moreHoriz", // Using string icon name instead of JSX
            () => onMoreInfo(giftCard), `More info for gift card ${giftCard.giftCardNumber}`, "default"));
        }
        const row = {
            giftCardNumber: giftCard.giftCardNumber,
            initialValue: setPriceWithCurrency(giftCard.initialValue, culture),
            balance: setPriceWithCurrency(giftCard.balance, culture),
            // Use Stack even for single action to maintain consistency and allow for future expansion
            actions: helpers.createStack("row", 1, actionButtons),
        };
        row.sender = `${giftCard.fromFirstName || ""} ${giftCard.fromLastName || ""}`.trim() || "Unknown";
        row.createdOn = giftCard.createdOn ? helpers.formatDate(giftCard.createdOn) : "Unknown";
        return row;
    };
    // Build the complete table structure using pure approach
    const tableData = buildResponsiveTableData({
        data: giftCards,
        columnConfig,
        rowMapper: mapGiftCardToRow,
        excludeColumns: excludeColumns,
    });
    return renderResponsiveTableComponents(tableData, {
        iconRegistry: {
            moreHoriz: MoreHorizIcon,
        },
    });
};
